// extracted by mini-css-extract-plugin
export default {"form_login":"subsidiaryModal_form_login__tStAd","form":"subsidiaryModal_form__pgV2c","change_password":"subsidiaryModal_change_password__XQWmd"};